export default __webpack_public_path__ + "static/media/IconF1.dc31b995.svg";